export default "__VITE_ASSET__DO$lYO9Y__"